import { BadgeType } from '@humi-design-library/components/Badge/types';
import { BenefitProvider } from '@models/benefits/benefit-provider.model';
import { ModelMixin } from '@models/core/base-generic.model';
import { File } from '../common/file.model';

export type BenefitInvoiceStatusType = 'unsynced' | 'syncing' | 'synced' | 'failed';

export class BenefitInvoice extends ModelMixin<BenefitInvoice>() {
    protected static _type = 'benefitInvoices';
    protected static _resource = 'benefitManagement/benefitInvoices';
    protected static _version = 'v2';
    protected static _serializeAttributes = ['benefitProviderId', 'fileId', 'period'];

    get status(): BenefitInvoiceStatusType {
        return this._attributes['status'];
    }

    set status(status: BenefitInvoiceStatusType) {
        this._attributes['status'] = status;
    }

    get statusBadgeType(): BadgeType {
        const statusBadgeTypes: { [key in BenefitInvoiceStatusType]: BadgeType } = {
            unsynced: 'default',
            syncing: 'warning',
            synced: 'success',
            failed: 'danger',
        };

        return statusBadgeTypes[this.status] ?? 'default';
    }

    get benefitProvider(): BenefitProvider | null {
        return this.hasOne(BenefitProvider, 'benefitProvider');
    }

    set benefitProvider(benefitProvider: BenefitProvider | null) {
        this.setOne('benefitProvider', benefitProvider, 'benefitProviderId');
    }

    get benefitProviderId(): number | null {
        return this._attributes['benefitProviderId'];
    }

    set benefitProviderId(benefitProviderId: number | null) {
        this._attributes['benefitProviderId'] = benefitProviderId;
    }

    get file(): File {
        return this.hasOne(File, 'file');
    }

    set file(file: File) {
        this.setOne('file', file, 'fileId');
    }

    get fileId(): number | null {
        return this._attributes['fileId'];
    }

    set fileId(fileId: number | null) {
        this._attributes['fileId'] = fileId;
    }

    get period(): Date | null {
        return this._attributes['period'];
    }

    set period(period: Date | null) {
        this._attributes['period'] = period;
    }
}
